<template>
    <div class="newsSlider__sliderContainer"
         v-cloak
         data-aos="fade"
         data-aos-easing="ease-in-sine"
         data-aos-duration="600"
         data-aos-offset="300"
         data-aos-delay="125"
    >
        <Splide class="newsSlider__slider" :options="options">
            <SplideSlide class="newsSlider__slide slide" v-for="(slide, i) in slides" :key="i">
                <NewsCard :url="slide.url"
                          :title="slide.title"
                          :categories="slide.categories"
                          :img="{
                              url: slide.img,
                              height: 284,
                              width: 546
                          }"
                          :colour="slide.colour"
                />
            </SplideSlide>
        </Splide>
    </div> <!-- .sliderWrap -->
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import { defineComponent, defineProps } from 'vue'
import NewsCard from './news_card.vue'

export default defineComponent({
    props: {
        slides: {
            type: Object,
        },
        options: {
            type: Object,
        },
        theme: {
            type: String,
            default: ""
        }
    },
    components: {
        Splide,
        SplideSlide,
        NewsCard
    }
});
</script>
